import React from "react";
import {
    Box,
    Paper,
    Typography,
    Divider,
} from "@mui/material";

import SolutionDetailSidebarInfo from "./Sidebar/SolutionDetailSidebarInfo";
import SolutionDetailSidebarRDD from "./Sidebar/SolutionDetailSidebarRDD";
import SolutionDetailSidebarShare from "./Sidebar/SolutionDetailSidebarShare";

const SolutionDetailSidebar = ({
    data,
    isAuthenticated,
    styles,

    title = "Project Details",

    showRDD = true,
    showShare = true,
    showOverlay = true,

    extraContent = null,
}) => {
    return (
        <Box className={styles.sidebar} sx={{ position: "relative" }}>
            <Paper
                className={styles.sidebarCard}
                elevation={2}
            >
                <Typography
                    variant="h4"
                    className={styles.sidebarTitle}
                >
                    {title}
                </Typography>

                <Divider sx={{ my: 2 }} />

                <SolutionDetailSidebarInfo
                    data={data}
                    styles={styles}
                />

                {showRDD && (
                    <SolutionDetailSidebarRDD
                        data={data}
                        styles={styles}
                    />
                )}

                {showShare && (
                    <SolutionDetailSidebarShare
                        data={data}
                        styles={styles}
                        isAuthenticated={isAuthenticated}
                    />
                )}
                {extraContent}
            </Paper>

        </Box>
    );
};

export default SolutionDetailSidebar;